import React from 'react';
import { Box, Stack, Typography } from '@mui/material';
import { FaInstagram } from 'react-icons/fa';
import { FaLinkedin } from 'react-icons/fa';

import Logo from '../assets/icons/dumbbell.png';
import ButtonTop from './ButtonTop';

const Footer = () => {
  return (
    <Box mt="-150px" bgcolor="#fed136" id="about">
      <ButtonTop />
      <Stack gap="10px" alignItems="center" px="40px" pt="24px">
        <div className="socialMedia">
          <a
            href="https://www.instagram.com/icwebw/"
            target="_blank"
            rel="noreferrer"
          >
            <FaInstagram className="insta" />
          </a>

          <a href="#toTop">
            <img
              style={{
                border: '3px solid #FF2625',
                borderRadius: '50px',
                padding: '10px',
              }}
              className="logo"
              src={Logo}
              alt="Logo"
              width="70px"
              height="70px"
            />
          </a>

          <a
            href="https://www.linkedin.com/in/pislaru-g-316205231/"
            target="_blank"
            rel="noreferrer"
          >
            <FaLinkedin className="linkedin" />
          </a>
        </div>
        <Typography mb="20px" fontWeight={700}>
          <a
            className="copy"
            href="https://www.i-create.tech"
            target="_blank"
            rel="noreferrer"
          >
            &copy; All rights reserved. - I-CREATE - {new Date().getFullYear()}.
          </a>
        </Typography>
      </Stack>
    </Box>
  );
};

export default Footer;
